/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 12:54 PM
 *
 */

import { CaretLeft, CaretRight, XCircle } from 'phosphor-react';
import { useAppDispatch, useAppSelector } from 'stores';
import { toggleOpen } from 'stores/slices/sideBarSlice';

const ToggleButton = () => {
  const open = useAppSelector((state) => state.sidebar.open);
  const dispatch = useAppDispatch();

  return (
    <>
      <div
        onClick={() => dispatch(toggleOpen())}
        className={`fixed top-6 z-50 h-11 w-11 bg-primary-500 text-2xl ${
          !open
            ? 'left-28 sm:hidden'
            : 'left-[26rem] translate-x-[-50%] lg:left-[28%] md:left-[37.5%] sm:hidden'
        } flex cursor-pointer items-center justify-center rounded-full text-white shadow-E200 transition-all duration-100 print:hidden`}
      >
        {!open ? <CaretRight weight="bold" /> : <CaretLeft weight="bold" />}
      </div>

      {open ? (
        <div
          className="text-primary fixed top-8 right-8 z-50 hidden cursor-pointer rounded-full bg-white shadow-E200 transition-all duration-100 sm:flex"
          onClick={() => dispatch(toggleOpen())}
        >
          <XCircle size={52} weight="fill" color="#111" />
        </div>
      ) : (
        <div
          className="text-primary fixed top-10 -right-64 z-50 hidden cursor-pointer rounded-full bg-white shadow-E200 transition-all duration-100 sm:flex"
          onClick={() => dispatch(toggleOpen())}
        >
          <XCircle size={52} weight="fill" color="#111" />
        </div>
      )}
    </>
  );
};

export default ToggleButton;
